import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoggedInGuard } from "./core/guards/logged-in.guard";
import { checkTokenGuard } from "./core/guards/checktoken.guard";
import { ClearStorageGuard } from "./core/guards/clear-storage.guard";
import { singleTabGuard } from "./single-tab.guard";

import { UserLayoutComponent } from "./pages/user/user-layout/user-layout.component";
import { HomeComponent } from "./pages/landing-pages/home/home.component";
import { DashboardComponent } from "./pages/user/user-layout/dashboard/dashboard.component";
import { SignInComponent } from "./pages/landing-pages/authentication/sign-in/sign-in.component";
import { RecoverPasswordComponent } from "./pages/landing-pages/authentication/recover-password/recover-password.component";
import { SetNewPasswordComponent } from "./pages/landing-pages/authentication/set-new-password/set-new-password.component";
import { ManageAppsComponent } from "./pages/user/user-layout/manage-apps/manage-apps.component";
import { VerifyInviteComponent } from "./pages/landing-pages/authentication/verify-invite/verify-invite.component";

const routes: Routes = [
  {
    canActivate: [singleTabGuard],
    path: "",
    pathMatch: "full",
    redirectTo: "sign-in",
  },
  {
    path: "home",
    component: HomeComponent,
  },
  {
    path: "reset-password/:token/:email",
    component: SetNewPasswordComponent,
  },
  {
    path: "user",
    component: UserLayoutComponent,
    canActivate: [LoggedInGuard, singleTabGuard],
    canDeactivate: [ClearStorageGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "prefix" },
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "system-config",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/system-config/system-config.module"
          ).then((m) => m.SystemConfigModule),
      },
      {
        path: "profile",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/profile-update/profile-update.module"
          ).then((m) => m.ProfileUpdateModule),
      },
      {
        path: "users",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/user-management/user-management.module"
          ).then((m) => m.UserManagementModule),
      },
      {
        path: "manage-devices",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/manage-devices/manage-devices.module"
          ).then((m) => m.ManageDevicesModule),
      },
      {
        path: "manage-merchants",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/manage-merchants/manage-merchants.module"
          ).then((m) => m.ManageMerchantsModule),
      },
      {
        path: "manage-clients",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/manage-banks/manage-banks.module"
          ).then((m) => m.ManageBanksModule),
      },
      {
        path: "manage-keys",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/cardkey-management/cardkey-management.module"
          ).then((m) => m.CardkeyManagementModule),
      },
      {
        path: "manage-aids",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/manage-aids/manage-aids.module"
          ).then((m) => m.ManageAidsModule),
      },
      {
        path: "geolocation",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/geolocation/geolocation.module"
          ).then((m) => m.GeolocationModule),
      },
      {
        path: "manage-oem",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/oem-management/oem-management.module"
          ).then((m) => m.OemManagementModule),
      },
      {
        path: "manage-apps",
        component: ManageAppsComponent,
      },
      {
        path: "manage-terminals",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/manage-terminals/manage-terminals.module"
          ).then((m) => m.ManageTerminalsModule),
      },
      {
        path: "audit-trail",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/audit-trail/audit-trail.module"
          ).then((m) => m.AuditTrailModule),
      },
      {
        path: "geolocation",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/geolocation/geolocation.module"
          ).then((m) => m.GeolocationModule),
      },
      {
        path: "remote-instruction",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/remote-instruction/remote-instruction.module"
          ).then((m) => m.RemoteInstructionModule),
      },
      {
        path: "task-management",
        loadChildren: () =>
          import(
            "./pages/user/user-layout/task-management/task-management.module"
          ).then((m) => m.TaskManagementModule),
      },
    ],
  },
  {
    path: "sign-in",
    component: SignInComponent,
    canActivate: [checkTokenGuard, singleTabGuard],
  },
  {
    path: "recover-password",
    component: RecoverPasswordComponent,
  },
  {
    path: "verify-user-account",
    component: VerifyInviteComponent,
  },
  {
    path: "set-new-password/:token",
    component: SetNewPasswordComponent,
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
